/* Footer collapsible rows on mobile, replicating the model's behaviour. */
(function () {
  var MQ = window.matchMedia('(max-width: 750px)');

  function blocks() {
    return document.querySelectorAll('.footer .footer-block');
  }

  function setup() {
    blocks().forEach(function (block) {
      if (block.dataset.aiAccordion === 'true') return;

      var heading = block.querySelector('.footer-block__heading');
      if (!heading) return;

      var content =
        block.querySelector('.footer-block__details-content') ||
        block.querySelector('.main-brand');

      if (!content) {
        var brand = block.querySelector('.footer-block__brand-info');
        if (!brand) return;
        var wrap = document.createElement('div');
        wrap.className = 'main-brand';
        var node = heading.nextElementSibling;
        while (node) {
          var next = node.nextElementSibling;
          wrap.appendChild(node);
          node = next;
        }
        brand.appendChild(wrap);
        content = wrap;
      }

      heading.classList.add('ced-accordion');
      content.classList.add('ced-accordion-content');
      block.dataset.aiAccordion = 'true';

      heading.addEventListener('click', function () {
        if (!MQ.matches) return;
        heading.classList.toggle('active');
        content.classList.toggle('active2');
      });
    });
  }

  function reset() {
    if (MQ.matches) return;
    document.querySelectorAll('.ced-accordion.active').forEach(function (el) {
      el.classList.remove('active');
    });
    document.querySelectorAll('.ced-accordion-content.active2').forEach(function (el) {
      el.classList.remove('active2');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }

  document.addEventListener('shopify:section:load', setup);
  MQ.addEventListener('change', reset);
})();
